module.exports = __webpack_public_path__ + "21c1dcb2f33e264c46f58e9457746c5f.png";